import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Language } from '../../data/translations';
const options: Language[] = ['es', 'en'];
export function LanguageToggle() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <div role="group" aria-label={t.nav.language} className="flex items-center text-[11px] font-medium tracking-[0.08em]" data-id="element-253" data-mp="2tobgk82490c8">
      {options.map((option, i) => <React.Fragment key={option} data-id="element-254" data-mp="32mdm90wsoh5u" data-mpi={i}>
          {i > 0 && <span className="px-1.5 text-white/25" aria-hidden="true" data-id="element-255" data-mp="37l86m7aeuds2">
              |
            </span>}
          <button type="button" onClick={() => setLang(option)} aria-pressed={lang === option} className={`rounded px-0.5 py-1 uppercase outline-none transition-colors duration-150 ease-out focus-visible:ring-1 focus-visible:ring-cyan ${lang === option ? 'text-white' : 'text-white/40 hover:text-white/80'}`} data-id="element-256" data-mp="3ce1aksy21i33">
            {option}
          </button>
        </React.Fragment>)}
    </div>;
}